// extracted by mini-css-extract-plugin
export default {"form":"Profile_form__b9jRB","form__submit_container":"Profile_form__submit_container__ZspVp"};